<script setup lang="ts">
// A run's state as a badge: colour and words together, never colour alone.
import { computed } from "vue";
import type { RunRecord } from "@/api/types";
import { runStatus, type Tone } from "@/lib/runState";

const props = defineProps<{ run?: RunRecord | null; tone?: Tone; label?: string }>();
const s = computed(() => (props.run ? runStatus(props.run) : { tone: props.tone ?? "idle", label: props.label ?? "" }));
</script>

<template>
  <span class="badge" :data-tone="s.tone"><span class="dot" :class="{ pulse: s.tone === 'working' }" aria-hidden="true" />{{ label ?? s.label }}</span>
</template>

<style scoped>
.dot { width: 5px; height: 5px; }
.pulse { animation: pulse-ring 1.8s var(--ease) infinite; }
</style>
